import React, { useState, useEffect, useLayoutEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import "../style/OtherProfile.css";
import StarGen from "../Component/StarSet"
import dishesData from '../assets/dishes2.json';
import { socket } from "../App";
import Modal from "./Modal";
import Null_Photo from "../assets/No_Photo.png";
import defaultAvatar from "../assets/OIP.jpg";

const resolveRestaurantImagePath = (path) => {
  if (!path) return Null_Photo;
  if (path.startsWith("http") || path.startsWith("data:")) return path;
  return process.env.NODE_ENV === "development"
    ? path
    : `https://webdev.cse.buffalo.edu/hci/teams/indecisive${path}`;
};

export const OtherProfile = () => {
  const { otherUserId } = useParams();
  const navigate = useNavigate();
  const myUserId = sessionStorage.getItem("user");
  const userToken = sessionStorage.getItem("token");
  const isLoggedIn = Boolean(userToken && myUserId);
  const [blocking, setBlocking] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const [username, setUsername] = useState("Username");
  const [picture, setPicture] = useState(defaultAvatar);
  const [description, setDescription] = useState("Another user's description here.");
  const [followerCount, setFollowerCount] = useState(0);
  const [followingCount, setFollowingCount] = useState(0);
  const [updateCheck, setUpdateCheck] = useState(true);
  const [selectedTab, setSelectedTab] = useState("reviews");
  const [connectionID, setConnectionID] = useState(null);
  const [posts, setPosts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [filter, setPrefernces] = useState([]);
  const [open, setOpen] = useState(false);
  
  
  const [favorites, setFavorites] = useState([]);
  const [dishRatings, setDishRatings] = useState({});
  const [isFollowing, setIsFollowing] = useState(false);
  const [showFollowDropdown, setShowFollowDropdown] = useState(false);
  const [isUserLoading, setIsUserLoading] = useState(true);
  const [isPostsLoading, setIsPostsLoading] = useState(true);
  const [isFavoritesLoading, setIsFavoritesLoading] = useState(true);
  const [error, setError] = useState(null);

  //Checking for if account blocked is in session storage.
  const blockedProfiles = sessionStorage.getItem("blockedProfiles");
  const blockingProfiles = sessionStorage.getItem("blockingProfiles");
  const [blockingList, setBlockingList] = useState([]);
  const [fetched, setFetched] = useState(false);
  

  useEffect(() => {
    if (otherUserId === myUserId) {
      navigate("/self");
    }
  }, [otherUserId, myUserId, navigate]);

  const handleClose = () => {
    setOpen(false);
};

const handleOpen = () => {
    setOpen(true);
};

const openFollowDropdown = () => {
  setShowFollowDropdown(true);
}

const closeFollowDropdown = () => {
  setShowFollowDropdown(false);
}

  useLayoutEffect(() => {
    // console.log("THIS IS THE ACCOUNTS THAT BLOCK YOU");
    // console.log(blockedProfiles)
    // console.log("THESE ARE THE ACCOUNTS YOU BLOCK");
    // console.log(blockingProfiles);
      if(sessionStorage.getItem("blockedProfiles") != null) {
        // console.log(blockedProfiles);
        if (blockedProfiles.includes(otherUserId)) {
          setBlocked(true);
        }
      }
    })
  
    const fetchUserData = async () => {
      try {
        // Fetch user details
        const response = await fetch(
          `${process.env.REACT_APP_API_PATH}/users/${myUserId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${userToken}`,
            },
          }
        ); 
  
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          console.error("Failed to fetch user data. Status:", response.status, "Response:", errorData);
          throw new Error(errorData.message || `Failed to fetch user data (${response.status})`);
        }
  
        const result = await response.json();
        // console.log("RESULTS!");
        // console.log(result);
        const newList = [];
        for (let entry in result.attributes.blockedPosts){
          blockingList.push(parseInt(entry));
        }
        // console.log("This is the new List!")
        // console.log(blockingList);
        setFetched(true);
      }
      catch (err) {
        return;
      }
    }
  useLayoutEffect(() => {
      const userData = fetchUserData();
      // console.log(userData);  
    },[]);
  

  useEffect(() => {
    const handleRoomCreated = async (data) => {
      if (data && data.roomID) {
        sessionStorage.setItem("toUserID", otherUserId);
        sessionStorage.setItem("roomID", data.roomID);
  
        const checkURL = `${process.env.REACT_APP_API_PATH}/connections?fromUserID=${myUserId}&toUserID=${otherUserId}`;
  
        const res = await fetch(checkURL, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        });
  
        const connectionData = await res.json();
        const exists = Array.isArray(connectionData[0]) && connectionData[0].length > 0;
  
        if (!exists) {
          try {
            await fetch(`${process.env.REACT_APP_API_PATH}/connections`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userToken}`,
              },
              body: JSON.stringify({
                fromUserID: parseInt(myUserId),
                toUserID: parseInt(otherUserId),
                attributes: {
                  roomid: data.roomID,
                },
              }),
            });
          } catch (error) {
            console.error("Failed to store roomID in connections:", error);
          }
        }
        sessionStorage.setItem("autoOpenRoomID", data.roomID);
        navigate(`/message`);
      }
    };
  
    socket.on("/room-created", handleRoomCreated);
    return () => socket.off("/room-created", handleRoomCreated);
  }, [navigate, otherUserId, myUserId, userToken]);
  
  const handleStartChat = async () => {
    socket.emit("/chat/join-room", {
      fromUserID: myUserId,
      toUserID: otherUserId,
    });
  };

  async function getAccountConnections() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_PATH}/connections?anyUserID=${otherUserId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          }
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch connections');
      }

      return response.json();
    } catch (error) {
      console.error("Error fetching connections:", error);
      return [[], 0];
    }
  }

  async function connectionHandler() {
    try {
      const jsonInfo = await getAccountConnections();
      let followers = 0;
      let following = 0;

      if (Array.isArray(jsonInfo[0])) {
        for (let conn = 0; conn < jsonInfo[0].length; conn++) {
          let curr = jsonInfo[0][conn];

          // Check if the user is blocking our currently logged in user
          if (curr.toUserID == myUserId && curr.attributes.additionalProp1.block) {
            setBlocked(true);
          }
          
          // Count followers: connections where profile owner is the "toUserID"
          if (curr.toUserID == otherUserId && !curr.attributes?.additionalProp1?.block) {
            followers++;
          } else if (curr.fromUserID == otherUserId && !curr.attributes?.additionalProp1?.block) {
            following++;
          }
        }
      }

      const followCheckResponse = await fetch(
        `${process.env.REACT_APP_API_PATH}/connections?fromUserID=${myUserId}&toUserID=${otherUserId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          }
        }
      );

      if (followCheckResponse.ok) {
        const followData = await followCheckResponse.json();
        if (followData[0] && followData[0].length > 0) {
          const connection = followData[0][0];
          setIsFollowing(true);
          setConnectionID(connection.id);
          if (connection.attributes?.additionalProp1?.block) {
            setBlocking(true);
          }
        }
      }

      setFollowerCount(followers);
      setFollowingCount(following);
    } catch (error) {
      console.error("Error in connection handler:", error);
      setFollowerCount(0);
      setFollowingCount(0);
    }
  }

  useEffect(() => {
    if (isLoggedIn && otherUserId && myUserId) {
      connectionHandler();
    }
  }, [isLoggedIn, otherUserId, myUserId]);

  useEffect(() => {
    if (!otherUserId) {
      setIsUserLoading(false);
      return;
    }

    const fetchOtherUserData = async () => {
      setIsUserLoading(true);
      setIsFavoritesLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_PATH}/users/${otherUserId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              ...(userToken && { "Authorization": `Bearer ${userToken}` })
            },
          }
        );

        if (!response.ok) {
          console.error("Failed to fetch other user data. Status:", response.status);
          throw new Error("Failed to fetch other user data");
        }

        const result = await response.json();
        if (result && result.attributes) {
          setPrefernces(result.attributes.filter);
          setUsername(result.attributes.username || `User${otherUserId}`);
          setPicture(result.attributes.picture || defaultAvatar);
          setDescription(result.attributes.description || "No description provided.");
          setFavorites(Array.isArray(result.attributes.favorites) ? result.attributes.favorites : []);
        } else {
          setFavorites([]);
        }
      } catch (error) {
        setError("Error loading other user's profile.");
        setFavorites([]);
      } finally {
        setIsUserLoading(false);
        setIsFavoritesLoading(false);
      }
    };
   

    fetchOtherUserData();
  }, [otherUserId, userToken]);

  // --- Fetch dish ratings for favorites ---
  useEffect(() => {
    if (!favorites || favorites.length === 0 || !isLoggedIn) return;
    
    const fetchDishRatings = async () => {
      try {
        // Get all posts to find reviews for each favorite dish
        const response = await fetch(
          `${process.env.REACT_APP_API_PATH}/posts?parentID=&limit=100`,
          {
            headers: {
              "Content-Type": "application/json",
              ...(userToken && { "Authorization": `Bearer ${userToken}` })
            },
          }
        );
        
        if (!response.ok) {
          throw new Error("Failed to fetch posts for ratings");
        }
        
        const result = await response.json();
        if (!result || !result[0] || !Array.isArray(result[0])) {
          console.warn("Unexpected posts data structure for ratings:", result);
          return;
        }
        
        const allPosts = result[0];
        const ratings = {};
        
        // For each favorite, find reviews and calculate average rating
        favorites.forEach(favorite => {
          const dishId = favorite.id;
          if (!dishId) return;
          
          // Find all reviews for this dish
          const dishReviews = allPosts.filter(post => 
            post.attributes?.dishID && 
            parseInt(post.attributes.dishID, 10) === parseInt(dishId, 10)
          );
          
          // If dish has reviews, calculate average rating
          if (dishReviews && dishReviews.length > 0) {
            const totalRating = dishReviews.reduce((sum, review) => {
              const rating = parseFloat(review.attributes.overallRating || review.attributes.rating) || 0;
              return sum + rating;
            }, 0);
            
            const avgRating = totalRating / dishReviews.length;
            ratings[dishId] = {
              averageRating: Math.round(avgRating * 10) / 10,
              reviewCount: dishReviews.length
            };
          } else {
            // No reviews found for this dish
            ratings[dishId] = { averageRating: 0, reviewCount: 0 };
            
            // Check if we can find this dish in dishes2.json for any preset ratings
            const dishData = dishesData.find(dish => dish.id === parseInt(dishId, 10));
            if (dishData && dishData.reviews && dishData.reviews.length > 0) {
              const staticReviews = dishData.reviews;
              const staticTotalRating = staticReviews.reduce((sum, review) => {
                return sum + (parseFloat(review.overallRating) || 5);
              }, 0);
              
              ratings[dishId] = {
                averageRating: Math.round((staticTotalRating / staticReviews.length) * 10) / 10,
                reviewCount: staticReviews.length
              };
            }
          }
        });
        
        setDishRatings(ratings);
      } catch (error) {
        console.error("Error fetching dish ratings:", error);
      }
    };
    
    fetchDishRatings();
  }, [favorites, isLoggedIn, userToken]);

  useEffect(() => {
    if (!otherUserId) {
      setIsPostsLoading(false);
      return;
    }

    const fetchUserPosts = async () => {
      setIsPostsLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_PATH}/posts?authorID=${otherUserId}&parentID=`,
          {
            headers: {
              "Content-Type": "application/json",
              ...(userToken && { "Authorization": `Bearer ${userToken}` })
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch other user's posts");
        }

        const result = await response.json();
        setPosts(Array.isArray(result[0]) ? result[0] : result);
        if (Array.isArray(result) && result.length === 2 && Array.isArray(result[0])) {
          setPosts(result[0]);
        } else {
          setPosts(Array.isArray(result) ? result : []);
        }
      } catch (error) {
        setPosts([]);
      } finally {
        setIsPostsLoading(false);
      }
    };

    fetchUserPosts();
  }, [otherUserId, userToken]);

  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };
  const DishCard = ({ postId, title, review, restaurant, overallRating, image, linkType }) => {
    let linkPath = "#";
    if (postId) {
      if (linkType === "review") {
        linkPath = `/reviewPost/${postId}`;
      } else if (linkType === "favorite") {
        linkPath = `/dish/${postId}`;
      }
    }
    
    // For favorites, use the calculated average rating from dishRatings
    const displayRating = linkType === "favorite" && dishRatings[postId] 
      ? dishRatings[postId].averageRating 
      : overallRating;
      
    // Only show rating if there are reviews (for favorites)
    const hasRating = linkType === "favorite" 
      ? (dishRatings[postId] && dishRatings[postId].reviewCount > 0)
      : !!overallRating;
    
    return (
      <Link to={linkPath} style={{ textDecoration: "none", color: "inherit" }}>
        <div className="otherprofile-dish">
          <img className="otherprofile-dish-img" alt={title} src={resolveRestaurantImagePath(image)} />
          <div className="otherprofile-dish-info">
            <h2>{title}</h2>
            {hasRating && (
              <div className="rating">
                <StarGen rating={displayRating} />
                {linkType === "favorite" && dishRatings[postId] && dishRatings[postId].reviewCount > 0 && (
                  <span className="review-count">({dishRatings[postId].reviewCount} {dishRatings[postId].reviewCount === 1 ? 'review' : 'reviews'})</span>
                )}
              </div>
            )}
            <p>{review}</p>
            <p><strong>{restaurant}</strong></p>
          </div>
        </div>
      </Link>
    );
  };

  const DishList = () => {
    if (isPostsLoading) {
      return (
        <div className="otherprofile-no-content-message">
          <h2>Loading Reviews...</h2>
        </div>
      );
    }
    
    if (posts.length === 0) {
      return (
        <div className="otherprofile-no-content-message">
          <h2>No Reviews Yet</h2>
        </div>
      );
    }
    
    const postRows = chunkArray(posts, 2);
    return (
      <>
        {postRows.map((row, rowIndex) => (
          <div key={rowIndex} className="otherprofile-dishes-row">
            {row.filter((row) => !blockingList.includes(row.id)).map((post, idx) => {
              if (!post?.attributes) return null;
              return (
                <DishCard
                  key={idx}
                  postId={post.id}
                  title={post.attributes.title || "Untitled Review"}
                  review={post.attributes.review || post.content}
                  restaurant={post.attributes.restaurant || "Unknown Restaurant"}
                  overallRating={post.attributes.overallRating || post.attributes.rating || 0}
                  image={post.attributes.image || Null_Photo}
                  linkType="review"
                />
              );
            })}
          </div>
        ))}
      </>
    );
  };

  const FavoritesList = () => {
    if (isFavoritesLoading) {
      return (
        <div className="otherprofile-no-content-message">
          <h2>Loading Favorites...</h2>
        </div>
      );
    }

    if (!favorites || favorites.length === 0) {
      return (
        <div className="otherprofile-no-content-message">
          <h2>No Items Favorited</h2>
        </div>
      );
    }

    const favoritesRows = chunkArray(favorites, 2);
    return (
      <div className="otherprofile-dishes-container">
        {favoritesRows.map((row, rowIndex) => (
          <div key={rowIndex} className="otherprofile-dishes-row">
            {row.map((favorite, idx) => (
              <DishCard
                key={idx}
                postId={favorite.id || favorite.postId}
                title={favorite.title || "Favorite Dish"}
                review={favorite.review || ""}
                restaurant={favorite.restaurant || ""}
                overallRating={favorite.overallRating || 5}
                image={favorite.image || Null_Photo}
                linkType="favorite"
              />
            ))}
          </div>
        ))}
      </div>
    );
  };

  async function handleFollowClick() {
    if (!isLoggedIn) {
      console.warn("User not logged in");
      return;
    }

    if (isFollowing) {
      setShowFollowDropdown((prev) => !prev);
      return;
    }

    try {
      const jsonBlob = {
        fromUserID: myUserId,
        toUserID: otherUserId,
        attributes: {
          additionalProp1: {
            block: false,
          },
        },
      };

      const response = await fetch(`${process.env.REACT_APP_API_PATH}/connections`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify(jsonBlob),
      });

      if (!response.ok) {
        throw new Error('Failed to create connection');
      }

      const result = await response.json();
      setConnectionID(result.id);
      setIsFollowing(true);
      closeFollowDropdown();
      await connectionHandler(); // Refresh counts
    } catch (error) {
      console.error("Error following user:", error);
    }
  }

  async function handleUnfollow() {
    if (!connectionID) {
      console.warn("No connection ID found");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/connections/${connectionID}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete connection');
      }

      setIsFollowing(false);
      setShowFollowDropdown(false);
      setConnectionID(null);
      closeFollowDropdown();
      await connectionHandler(); // Refresh counts
    } catch (error) {
      console.error("Error unfollowing user:", error);
    }
  }

  const handleBlock = async () => {
    const jsonBlob = {
      fromUserID: myUserId,
      toUserID: otherUserId,
      attributes: {
        additionalProp1: {
          block: true,
        },
      },
    };
    
    if (connectionID != null) {
      await fetch(`${process.env.REACT_APP_API_PATH}/connections/${connectionID}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      });
    }

    const res = await fetch(`${process.env.REACT_APP_API_PATH}/connections`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify(jsonBlob),
    });
    // console.log("This is our result");
    const newId = await res.json()
    // console.log("THIS IS YOUR NEW ID!")
    // console.log(newId);
    setConnectionID(newId.id);


    

    // alert("User blocking (placeholder).");
    setShowFollowDropdown(false);
    setBlocking(true);
    setIsFollowing(false);
    const blockedSet = JSON.parse(sessionStorage.getItem("blockingProfiles"));
    blockedSet.push(otherUserId);
    sessionStorage.setItem("blockingProfiles",JSON.stringify(blockedSet));
    handleClose();
    closeFollowDropdown();
  };


  function PrefModal({ onClose }) {
    return (
      <div className="pref-pop">
        <div>
          <h3 className="fredoka-custom">{username}'s Food Choices</h3>
          {filter && filter.length > 0 ? (
    filter.map((item, index) => (
      <div key={index} className="option">
        {item}
      </div>
    ))
  ) : (
    <p>No food choices set.</p>
  )}
<br></br> <br></br>
          <button className="close-pref" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    );
  }

  function BlockModal({ onClose }) {
    return (
      <div className="pref-pop">
        <div>
          <h3 className="fredoka-custom">Are you sure you want to block this user?</h3>

<br></br> <br></br>
          <button style={{marginRight: "90px"}} className="close-pref" onClick={handleBlock}>
            Yes
          </button>
          
          <button className="close-pref" onClick={handleClose}>
            No
          </button>
        </div>
      </div>
    );
  }

  const handleUnblock = async () => {
    const jsonBlob = {
      fromUserID: myUserId,
      toUserID: otherUserId,
      attributes: {
        additionalProp1: {
          block: false,
        },
      },
    };

    // console.log("CALLING A DELETE CALL")
    // console.log(connectionID);

    const response = await fetch(`${process.env.REACT_APP_API_PATH}/connections/${connectionID}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
    });

    // alert("User unblocking (placeholder).");
    setShowFollowDropdown(false);
    setBlocking(false);
    setIsFollowing(false);
    setConnectionID(null);
    
    let currList = JSON.parse(sessionStorage.getItem("blockingProfiles"));
    // console.log("CURR LIST");
    // console.log(currList);
    const newList = currList.filter((index) => index != otherUserId);
    // console.log("NEW LIST!!!!")
    // console.log(newList);
    sessionStorage.setItem('blockingProfiles',JSON.stringify(newList));
  };

  // console.log(`BLOCKING STATUS IS ${blocking}`);
  // console.log(`BLOCKED STATUS IS ${blocked}`);
  // console.log(`ConnectionID: ${connectionID}`);

  // ---------------------------
  // Render
  // ---------------------------

  if (blocked) {
    return(
      <h1>Profile Not Avaliable</h1>
    )
  }

  if (open) {
      return (
        <div>
        <BlockModal></BlockModal>
        </div>
      )
    }
  return (
    <div className="otherprofile-container">
      {(isUserLoading || isPostsLoading) ? (
        <div className="otherprofile-no-content-message">
          <h2>Loading Profile...</h2>
        </div>
      ) : error ? (
        <div className="otherprofile-no-content-message">
          <h2>{error}</h2>
        </div>
      ) : (
        <>
          <section className="otherprofile-user-profile">
            <div className="otherprofile-left-col">
              <img className="otherprofile-avatar" alt="User Avatar" src={picture} />
              <div className="otherprofile-user-info">
                <h1 className="otherprofile-user-name">{username}</h1>
                <button className="pref-box" onClick={() => setModalOpen(true)}>
             {username}'s Food Choices
        </button>
        {modalOpen && <PrefModal onClose={() => setModalOpen(false)} />}

                <p className="otherprofile-user-desc">{description}</p>
              </div>
            </div>

            <div className="otherprofile-right-col">
              <div className="otherprofile-user-stats">
                {(!blocked && !blocking) &&
                <Link to={`/followers/${otherUserId}`}>
                  <p>{followerCount} Followers</p>
                </Link>}
                {(!blocked && !blocking) &&
                <Link to={`/following/${otherUserId}`}>
                  <p>{followingCount} Following</p>
                </Link>
                }
              </div>
            </div>

            {isLoggedIn && (
              <div className="otherprofile-action-buttons">
                <div className="follow-button-container" style={{ position: "relative" }}>
                  <button
                    className={
                      blocking ? ("otherprofile-blocking") :
                      isFollowing ? ("otherprofile-follow-button following"):
                      ("otherprofile-follow-button")  
                    }
                    onClick={
                      showFollowDropdown ? closeFollowDropdown : openFollowDropdown
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                      <span onClick={blocking ? null : handleFollowClick} className="follow-text">
                        {
                          blocking ? `Blocking` : `Follow`
                        }
                      </span>
                        <span onClick={openFollowDropdown}className="dropdown-icon">
                          {showFollowDropdown ? "▲" : "▼"}
                        </span>
                  </button>

                  {showFollowDropdown && (
                    <div className="otherprofile-follow-dropdown">
                      {(!blocking && isFollowing) && (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleUnfollow();
                        }}
                        className="unfollow-button"
                      >Unfollow</button>)}

                      {!blocking && (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpen();
                          }}
                          className="block-button"
                        >Block</button>

                      )}
                      {blocking && (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUnblock();
                          }}
                          className="block-button"
                        >
                          Unblock
                        </button>
                      )}
                    </div>
                  )}
                </div>
                <button
                  className="otherprofile-message-button"
                  onClick={handleStartChat}
                >
                  Message
                </button>
              </div>
            )}
          </section>
          <nav className="otherprofile-reviews-favorites-bar">
            <div
              className={`otherprofile-tab ${selectedTab === "reviews" ? "otherprofile-tab-active" : ""}`}
              onClick={() => setSelectedTab("reviews")}
            >
              Reviews ({posts?.length || 0})
            </div>
            <div
              className={`otherprofile-tab ${selectedTab === "favorites" ? "otherprofile-tab-active" : ""}`}
              onClick={() => setSelectedTab("favorites")}
            >
              Favorites ({favorites?.length || 0})
            </div>
          </nav>
          {isLoggedIn && blocking && <h1>You have blocked this user</h1>}
          {isLoggedIn && blocked && !blocking && <h1>Content Not Available</h1>}
          {(!isLoggedIn || (!blocked && !blocking)) &&
            (selectedTab === "reviews" ? <DishList /> : <FavoritesList />)}
        </>
      )}
    </div>
  );

  return null;
};

export default OtherProfile;
